import React from 'react';
import type { GetProductDetailsToolPart } from '../../types/conciergeToolTypes';
import { isCallState, isOutputState } from './types';

export function ProductDetailsPart({
  part,
  onProductClick,
  pdpStacklineSku,
}: {
  part: GetProductDetailsToolPart;
  onProductClick?: (sku: string) => void;
  pdpStacklineSku?: string | null;
}) {
  if (isCallState(part.state)) return null;

  const output = part.output;
  if (isOutputState(part.state) && output?.products?.length && output.products.length > 0) {
    const products = output.products;
    const isPdpContext =
      !!(pdpStacklineSku && products.every((p) => p.stacklineSku === pdpStacklineSku)) ||
      !!output.fromPdp;

    if (isPdpContext) return null;

    return (
      <div className="concierge-product-details">
        {products.map((p: any, i: number) => (
          <div
            key={p.stacklineSku || i}
            className="concierge-product-detail-card"
            onClick={() => onProductClick?.(p.stacklineSku)}
            role="button"
            tabIndex={0}
          >
            {p.imageUrl && <img src={p.imageUrl} alt={p.title} />}
            <div>
              <div>{p.brand}</div>
              <div>{p.title}</div>
              <div>${p.price != null ? Number(p.price).toFixed(2) : ''}</div>
              {p.description && <div>{p.description}</div>}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return null;
}
